import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=a2b57834"
import script from "./PayPal.vue?vue&type=script&lang=js"
export * from "./PayPal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports